export const topRowSamples = [

    {
        keyCode: "81",
        sample: "low conga",
        id: "q",
        url: 'TR-505Conga_Lo.wav'
        // url: 'https://s3.us-east-2.amazonaws.com/4543721.drummy/TR-505Conga_Lo.wav'
    },
    {
        keyCode: "87",
        sample: "hi conga",
        id: "w",
        url: 'TR-505Conga_Hi.wav'
        // url: 'https://s3.us-east-2.amazonaws.com/4543721.drummy/TR-505Conga_Hi.wav'
    },
    {
        keyCode: "69",
        sample: "timbale",
        id: "e",
        url: 'TR-505Timbale.wav'
        // url: 'https://s3.us-east-2.amazonaws.com/4543721.drummy/TR-505Timbale.wav'
    },
    {
        keyCode: "82",
        sample: "low cowbell",
        id: "r",
        url: 'TR-505Cow_Lo.wav'
        // url: 'https://s3.us-east-2.amazonaws.com/4543721.drummy/TR-505Cow_Lo.wav'
    },
    {
        keyCode: "85",
        sample: "hi cowbell",
        id: "u",
        url: '/TR-505Cow_Hi.wav'
        // url: 'https://s3.us-east-2.amazonaws.com/4543721.drummy/TR-505Cow_Hi.wav'
    },
    {
        keyCode: "73",
        sample: "hand clap",
        id: "i",
        url: 'TR-505Clap.wav'
        // url: 'https://s3.us-east-2.amazonaws.com/4543721.drummy/TR-505Clap.wav'
    },
    {
        keyCode: "79",
        sample: "crash cymbal",
        id: "o",
        url: 'TR-505Crash.wav'
        // url: 'https://s3.us-east-2.amazonaws.com/4543721.drummy/TR-505Crash.wav'
    },
    {
        keyCode: "80",
        sample: "ride cymbal",
        id: "p",
        url: 'TR-505Ride.wav'
        // url: 'https://s3.us-east-2.amazonaws.com/4543721.drummy/TR-505Ride.wav'
    }
]

export const bottomRowSamples = [
    {
        keyCode: "65",
        sample: "kick",
        id: "a",
        url: 'TR-505Kick.wav'
        // url: 'https://s3.us-east-2.amazonaws.com/4543721.drummy/TR-505Kick.wav'
    },
    {
        keyCode: "83",
        sample: "snare",
        id: "s",
        url: 'TR-505Snare.wav'
        // url: 'https://s3.us-east-2.amazonaws.com/4543721.drummy/TR-505Snare.wav'
    },
    {
        keyCode: "68",
        sample: "low tom",
        id: "d",
        url: 'TR-505Tom_Lo.wav'
        // url: 'https://s3.us-east-2.amazonaws.com/4543721.drummy/TR-505Tom_Lo.wav'
    },
    {
        keyCode: "70",
        sample: "mid tom",
        id: "f",
        url: 'TR-505Tom_Mid.wav'
        // url: 'https://s3.us-east-2.amazonaws.com/4543721.drummy/TR-505Tom_Mid.wav'
    },
    {
        keyCode: "74",
        sample: "hi tom",
        id: "j",
        url: 'TR-505Tom_Hi.wav'
        // url: 'https://s3.us-east-2.amazonaws.com/4543721.drummy/TR-505Tom_Hi.wav'
    },
    {
        keyCode: "75",
        sample: "rim shot",
        id: "k",
        url: 'TR-505Rim.wav'
        // url: 'https://s3.us-east-2.amazonaws.com/4543721.drummy/TR-505Rim.wav'
    },
    {
        keyCode: "76",
        sample: "closed hi-hat",
        id: "l",
        url: 'TR-505Hat_C.wav'
        // url: 'https://s3.us-east-2.amazonaws.com/4543721.drummy/TR-505Hat_C.wav'
    },
    {
        keyCode: "186",
        sample: "open hi-hat",
        id: ";",
        url: 'TR-505Hat_O.wav'
        // url: 'https://s3.us-east-2.amazonaws.com/4543721.drummy/TR-505Hat_O.wav'
    }

]

export const startAndStop = [

    {
        keyCode: "13",
        function: "start",
        id: "enter",
    },
    {
        keyCode: "61",
        function: "stop",
        id: "delete"
    }

]